import React from "react";

import { CollapseIcon as Collapse, RefreshIcon as Refresh } from "@packages/ds";
import { useIntl } from "react-intl";

import Button from "ds/Button";
import { useGetServiceProcesses } from "Reducers/serviceProcesses/hooks/useGetServiceProcesses";
import { selectServicesProcesses } from "Reducers/serviceProcesses/serviceProcesses.selectors";
import { Status } from "Reducers/types";
import { useAppSelector } from "Store/hooks";

import { useTimeAgo } from "../hooks/useTimeAgo";

import { TableTreeDefaultButton } from "./ProcessesButtons";
import * as S from "./ProcessesHeaderFullScreen.styles";

export type ProcessesHeaderFullScreenProps = {
  fullScreen: boolean;
  setIsFullScreen: (open: boolean) => void;
};

export const ProcessesHeaderFullScreen = ({
  setIsFullScreen,
  fullScreen
}: ProcessesHeaderFullScreenProps) => {
  const { formatMessage } = useIntl();
  const reloadServiceProcesses = useGetServiceProcesses();
  const [timeAgo, resetTimeAgo] = useTimeAgo();
  const { data: serviceProcesses, status } = useAppSelector(
    selectServicesProcesses
  );

  const onRefresh = () => {
    resetTimeAgo();
    reloadServiceProcesses();
  };

  return (
    <S.RefreshSectionRoot>
      <S.CustomTypographyTitle tag="h3" color="white">
        {formatMessage({ id: "services.process.title" })}
      </S.CustomTypographyTitle>

      <S.RefreshRightSection>
        <S.CustomTypographyLabel as="span">
          {formatMessage(
            { id: "services.process.refresh.total" },
            {
              count: serviceProcesses.length
            }
          )}
        </S.CustomTypographyLabel>

        <Button
          analyticId="services.process.refresh.total"
          content="mixed"
          variant="dark"
          onClick={onRefresh}
          disabled={status === Status.Loading}
        >
          <Refresh /> {timeAgo}
        </Button>

        <TableTreeDefaultButton
          onClick={() => {
            setIsFullScreen(!fullScreen);
          }}
        >
          <Collapse />
        </TableTreeDefaultButton>
      </S.RefreshRightSection>
    </S.RefreshSectionRoot>
  );
};
